module.exports = "/_next/static/images/3afe57c3c3412705e9023977c96e0d33-man-looking-at-phone@md-2x.jpg.webp";